<template>
  <div class="footer-bottom-text__wrapper">
    <p class="footer-bottom-text__section">
      <span class="footer-bottom-text__section-name bold">
        {{ HIGH_RISK_WARNING_TITLE }}
      </span>
      <span class="footer-bottom-text__section-text">
        {{ HIGH_RISK_WARNING_TEXT }}
      </span>
    </p>
    <p class="footer-bottom-text__section">
      <span class="footer-bottom-text__section-name bold">
        {{ ADVISORY_WARNING_TITLE }}
      </span>
      <span class="footer-bottom-text__section-text">
        {{ ADVISORY_WARNING_TEXT }}
      </span>
    </p>
    <p class="footer-bottom-text__section">
      <span class="footer-bottom-text__section-name bold">
        {{ DISCLAIMER_TITLE }}
      </span>
      <span class="footer-bottom-text__section-text">
        {{ DISCLAIMER_TEXT }}
      </span>
    </p>
    <i class="footer-bottom-text__horizontal-divider" />
    <div class="footer-bottom-text__read">
      <p>
        {{ BILLING_ADDRESS }}
        <a-link class="footer-bottom-text__link" :to="ULTIMATE_GROUP_LINK">
          Ultimate Group
        </a-link>
      </p>
      <p>
        Read our
        <a-link class="footer-bottom-text__link" :to="linkToTerms">Terms</a-link
        >,
        <a-link class="footer-bottom-text__link" :to="linkToCookies"
          >Cookies</a-link
        >
        and
        <a-link class="footer-bottom-text__link" :to="linkToPrivacy"
          >Privacy Notice</a-link
        >
      </p>
      <footer-manage-cookies />
    </div>
  </div>
</template>

<script>
import {
  HIGH_RISK_WARNING_TITLE,
  HIGH_RISK_WARNING_TEXT,
  ADVISORY_WARNING_TITLE,
  ADVISORY_WARNING_TEXT,
  DISCLAIMER_TITLE,
  DISCLAIMER_TEXT,
  BILLING_ADDRESS,
  ULTIMATE_GROUP_LINK
} from '@/utils/enums/footer'
import { ROUTE_NAME } from 'enums/routes'
import FooterManageCookies from './FooterManageCookies'

export default {
  name: 'FooterBottomText',
  components: {
    FooterManageCookies
  },
  data() {
    return {
      HIGH_RISK_WARNING_TITLE,
      HIGH_RISK_WARNING_TEXT,
      ADVISORY_WARNING_TITLE,
      ADVISORY_WARNING_TEXT,
      DISCLAIMER_TITLE,
      DISCLAIMER_TEXT,
      BILLING_ADDRESS,
      ULTIMATE_GROUP_LINK,
      linkToTerms: {
        name: ROUTE_NAME.TERMS_OF_USE
      },
      linkToPrivacy: {
        name: ROUTE_NAME.PRIVACY
      },
      linkToCookies: {
        name: ROUTE_NAME.COOKIES
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-bottom-text__wrapper {
  color: $c--gray-light;
  .footer-bottom-text__section {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .footer-bottom-text__section-name {
    font-size: 11px;
  }

  .footer-bottom-text__section-text {
    font-size: 11px;
  }

  .footer-bottom-text__read {
    font-size: 12px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    color: $c--white;
  }

  .footer-bottom-text__horizontal-divider {
    display: block;
    width: 100%;
    height: 1px;
    background: #ffffff40;
    margin: 24px 0;
  }

  .footer-bottom-text__link {
    color: $c--main;

    &:hover {
      color: $c--main;
    }
  }
}
</style>
